<template>
  <div
    v-if="!$core.$uiState.isOnline"
    class="text-danger offline-detect-message"
  >
    インターネット接続がオフラインです。データの取得・更新はできません。
  </div>
</template>
<script lang="ts">
export default {
  name: 'OfflineDetectMessage',
}
</script>

<style lang="scss">
.offline-detect-message {
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  background-color: rgba(11, 13, 20, 0.85);
  font-weight: bold;
  padding: 0.5em 1em;
  z-index: 2000;
}
</style>
